import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { busType, calcDuration, formatTime24h } from "../../../../helpers";
import BookingPolicies from "../../BookingPolicies";
import BusPhoto from "../../BusPhoto/BusPhoto.jsx";
import BusSeat from "../../BusSeat/index.jsx";
import Reviews from "../../Reviews/";
import {
  BookingBtn,
  BusDetailsLink,
  BusDetailsLinkWrapper,
  CardWrapper,
  InnerHeader,
  InnerRow,
  InnerRowLeft,
  InnerRowright,
  SingleCard,
  SingleList,
} from "./BusName.styles.js";

const CarName = ({ tripData, fleet, setRoundCheck,setFirstJourneyDateCheck }) => {
  const { webSettingData, languageData } = useSelector(
    (state) => state.busLists
  );

  const [location, setLocation] = useState([]);
  const [singleCarPhoto, setSinglePhoto] = useState([]);
  const [showCarPhoto, setShowCarPhoto] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [showBookingPolicies, setShowBookingPolicies] = useState(false);
  const [showBusSeat, setShowBusSeat] = useState(false);
  // const [languageData, setLanguageData] = useState();

  const pickLocation = location.find(
    (item) => item?.id === tripData?.pick_location_id
  );

  const dropLocation = location.find(
    (item) => item?.id === tripData?.drop_location_id
  );
  console.log("tripData", tripData);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/vehicles/${tripData.vehicle_id}`
    )
      .then((res) => res.json())
      .then((data) => setSinglePhoto(data.data));
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/locations`)
      .then((res) => res.json())
      .then((data) => setLocation(data.data));
  }, []);
  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/localize/strings`)
  //     .then((res) => res.json())
  //     .then((data) => setLanguageData(data.data));
  // }, []);

  const showPhoto = () => {
    setShowCarPhoto((prevState) => !prevState);
    setShowReview(false);
    setShowBookingPolicies(false);
    setShowBusSeat(false);
  };

  const handleShowReview = () => {
    setShowReview((prevState) => !prevState);
    setShowCarPhoto(false);
    setShowBookingPolicies(false);
    setShowBusSeat(false);
  };

  const handleShowBookingPolicies = () => {
    setShowBookingPolicies((prevState) => !prevState);
    setShowReview(false);
    setShowCarPhoto(false);
    setShowBusSeat(false);
  };
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    // Load existing bookings from localStorage when the component mounts
    const storedBookings = localStorage.getItem("bookingInfo");
    if (storedBookings) {
      setBookings(JSON.parse(storedBookings));
    }
  }, []);
  const showSeat = () => {
    setRoundCheck(true);
    setShowBusSeat((prevState) => !prevState);
    setShowBookingPolicies(false);
    setShowReview(false);
    setShowCarPhoto(false);

    // While show the seats
    const bookingInfo = {
      trip_id: tripData.trip_id,
      subtripId: tripData.subtripId,
      vehicle_id: tripData.vehicle_id,
      cseat: String(tripData.child_seat),
      spseat: String(tripData.special_seat),
    };

    // Update the state with the new booking
    setBookings((prevBookings) => {
      const updatedBookings = bookingInfo;
      // Save the updated bookings to localStorage
      localStorage.setItem("bookingInfo", JSON.stringify(updatedBookings));
      return updatedBookings;
    });

    //  localStorage.setItem("bookingInfo", JSON.stringify(bookingInfo));
  };

  return (
    <CardWrapper>
      <SingleCard>
        <InnerHeader>
          <SingleList>
            <h5>{tripData?.company_name}</h5>
            <span>{busType(fleet, tripData?.fleet_id)}</span>
          </SingleList>
          <SingleList>
            <h5>{formatTime24h(tripData?.start_time)}</h5>
            <span>{pickLocation?.name}</span>
          </SingleList>
          <SingleList>
            <h5>
              {tripData?.journey_hour
                ? `${tripData.journey_hour}h`
                : (calcDuration(tripData?.start_time, tripData?.end_time) || '—')}
            </h5>
          </SingleList>
          <SingleList>
            <h5>{formatTime24h(tripData?.end_time)}</h5>
            <span>{dropLocation?.name}</span>
          </SingleList>
          <SingleList>
            <h5>{tripData?.rating}</h5>
          </SingleList>
          <SingleList>
            <h5>
              {Number(tripData.adult_fair).toLocaleString("fr-FR")} {webSettingData?.currency_symbol}
            </h5>
          </SingleList>
          <SingleList>
            <h5>
              {tripData?.available_seat}{" "}
              {
                languageData?.booking_page_card_title_seat_available[
                  webSettingData?.language
                ]
              }
            </h5>
            {/* <span>15 Windows</span> */}
          </SingleList>
        </InnerHeader>
        <InnerRow>
          <InnerRowLeft>
            <BusDetailsLinkWrapper>
              <BusDetailsLink
                onClick={showPhoto}
                btnhvcolor={webSettingData?.buttoncolor}
                btncolor={
                  showCarPhoto ? webSettingData?.buttoncolor : "undefined"
                }
              >
                {
                  languageData?.booking_page_card_bus_photos_btn[
                    webSettingData?.language
                  ]
                }
              </BusDetailsLink>
              <BusDetailsLink
                onClick={handleShowReview}
                btnhvcolor={webSettingData?.buttoncolor}
                btncolor={
                  showReview ? webSettingData?.buttoncolor : "undefined"
                }
              >
                {
                  languageData?.booking_page_card_reviews_btn[
                    webSettingData?.language
                  ]
                }
              </BusDetailsLink>
              <BusDetailsLink
                onClick={handleShowBookingPolicies}
                btnhvcolor={webSettingData?.buttoncolor}
                btncolor={
                  showBookingPolicies
                    ? webSettingData?.buttoncolor
                    : "undefined"
                }
              >
                {
                  languageData?.booking_page_card_booking_policies_btn[
                    webSettingData?.language
                  ]
                }
              </BusDetailsLink>
              <BusDetailsLink
                onClick={showSeat}
                btnhvcolor={webSettingData?.buttoncolor}
                btncolor={
                  showBusSeat ? webSettingData?.buttoncolor : "undefined"
                }
              >
                {
                  languageData?.booking_page_card_view_seats_btn[
                    webSettingData?.language
                  ]
                }
              </BusDetailsLink>
            </BusDetailsLinkWrapper>
          </InnerRowLeft>
          <InnerRowright>
            <BookingBtn
              onClick={showSeat}
              btnbgcolor={webSettingData?.buttoncolor}
              btnbghvcolor={webSettingData?.buttoncolorhover}
              btntextcolor={webSettingData?.buttontextcolor}
            >
              {
                languageData?.booking_page_card_book_btn[
                  webSettingData?.language
                ]
              }
            </BookingBtn>
          </InnerRowright>
        </InnerRow>
      </SingleCard>

      {showCarPhoto && <BusPhoto singleBusPhoto={singleCarPhoto.allimg} />}
      {showReview && (
        <Reviews id={tripData?.subtripId} webSettingData={webSettingData} />
      )}
      {showBookingPolicies && <BookingPolicies />}
      {showBusSeat && <BusSeat setFirstJourneyDateCheck={setFirstJourneyDateCheck} tripData={tripData} />}
    </CardWrapper>
  );
};

export default CarName;
